import React, { useEffect } from 'react';

import { Modal } from 'antd';
import dayjs from 'dayjs';
import styled from 'styled-components';

import { SNAPSHOT_SELECTOR_SELECTION } from './constants';
import { useSnapshotEditorContext } from './SnapshotEditorContext';
import SnapshotEditorModalActions from './SnapshotEditorModalActions';
import SnapshotEditorModalHeader from './SnapshotEditorModalHeader';
import SnapshotEditorModalSelection from './SnapshotEditorModalSelection';
import { SnapshotDataType } from '../../../types/snapshot';
import { SNAPSHOT_MODAL_STEP } from '../constants';
import { useSnapshotContext } from '../SnapshotContext';

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 0px;
    padding: 0;
  }

  .ant-modal-footer {
    margin: 0;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 700px;
  line-height: normal;
`;

const SnapshotEditorModal = () => {
  const { snapshot, historicalSnapshots } = useSnapshotContext();
  const { step, setStep, setSelection, setDate, setSelectedHistoricalSnapshot } = useSnapshotEditorContext();

  useEffect(() => {
    if (historicalSnapshots?.length) {
      const preselectedHistoricalSnapshotIndex = historicalSnapshots.findIndex(
        (item: SnapshotDataType) => item.uuid === snapshot?.uuid
      );
      const historicalSnapshotIndex = preselectedHistoricalSnapshotIndex >= 0 ? preselectedHistoricalSnapshotIndex : 0;
      setSelectedHistoricalSnapshot(historicalSnapshots[historicalSnapshotIndex]);
    }
  }, []);

  const handleClose = () => {
    setStep(SNAPSHOT_MODAL_STEP.DEFAULT);
    setDate(dayjs().subtract(1, 'day'));
    setSelection(SNAPSHOT_SELECTOR_SELECTION.ENTER_NEW_DATA);
    setSelectedHistoricalSnapshot(undefined);
  };

  const handleNext = () => {
    setSelection(SNAPSHOT_SELECTOR_SELECTION.ENTER_HISTORICAL_DATA);
    setStep(SNAPSHOT_MODAL_STEP.DATA);
  };

  return (
    <StyledModal
      open={step === SNAPSHOT_MODAL_STEP.EDITOR}
      footer={false}
      closable
      onCancel={handleClose}
      destroyOnClose
      width={540}
      style={{ padding: 0 }}
    >
      <Container>
        <SnapshotEditorModalHeader />
        <SnapshotEditorModalSelection />
        <SnapshotEditorModalActions onNext={handleNext} onClose={handleClose} />
      </Container>
    </StyledModal>
  );
};

export default SnapshotEditorModal;
